import { createReducer, on } from '@ngrx/store';
import * as ParametrizacionActions from '../actions/parametrizacion-focun.actions';

export interface ParametrizacionFocunState {
  parametrizacionFocunOnboarding: boolean;
}

export const initialState: ParametrizacionFocunState = {
  parametrizacionFocunOnboarding: false
};

export const parametrizacionFocunReducer = createReducer(
  initialState,

  on(ParametrizacionActions.setParametrizacionFocunOnboarding, (state, { status }) => ({
    ...state,
    parametrizacionFocunOnboarding: status
  })),


);
